export default __webpack_public_path__ + "static/favicon-78b94f398e18f01c6f43cff81609c93c.ico";